import React from 'react'
import PropTypes from 'prop-types'
import styles from './_heading.css'
import classnames from 'classnames'
import { DesktopView, TabletView, MobileView } from '../../layout/responsive_container'

const Heading = (props) => {
  const {
    desktopFontSize = '48px',
    tabletFontSize = '42px',
    mobileFontSize = '36px',
  } = props
  return (
    <React.Fragment>
      <DesktopView>
        <Content {...props} fontSize={ desktopFontSize } />
      </DesktopView>
      <TabletView>
        <Content {...props} fontSize={ tabletFontSize } />
      </TabletView>
      <MobileView>
        <Content {...props} fontSize={ mobileFontSize } />
      </MobileView>
    </React.Fragment>
  )
}

const Content = (props) => {
  const {
    children,
    align,
    topBar,
    bottomBar,
    color = 'black',
    headingClassName = '',
    letterSpacing = '6px',
    barClassName = '',
    barWidth = '87px',
    fontSize,
  } = props

  const headingStyles = {
    color: color,
    letterSpacing,
    fontSize,
  }

  const ruleStyles = {
    borderColor: color,
    width: barWidth,
  }

  const alignClass = align ? `align--${align}` : 'align--left'

  const classNames = classnames(styles.heading, headingClassName, styles[alignClass])

  const combinedBarClassNames = classnames(styles.bar, barClassName)

  return (
    <h2 className={classNames} style={headingStyles}>
      { topBar ? <hr className={combinedBarClassNames} style={ruleStyles} /> : null }
      {children}
      { bottomBar ? <hr className={combinedBarClassNames} style={ruleStyles} /> : null }
    </h2>
  )
}

Heading.propTypes = {
  desktopFontSize: PropTypes.string,
  tabletFontSize: PropTypes.string,
  mobileFontSize: PropTypes.string,
}

Content.propTypes = {
  align: PropTypes.string,
  children: PropTypes.node,
  color: PropTypes.string,
  topBar: PropTypes.bool,
  bottomBar: PropTypes.bool,
  headingClassName: PropTypes.string,
  letterSpacing: PropTypes.string,
  barClassName: PropTypes.string,
  barWidth: PropTypes.string,
  fontSize: PropTypes.string,
}

export default Heading
